//目录管理
import httpUtil from './base/httpUtil'
export default {
    //发送验证码
    getList(that,params,callback,error){
        httpUtil.httpGet(that,'/api/mini_program/get_card_list', params,function (res) {
          callback(res)
        },function (err) {
            console.log('err get' + err)
            if(error){
                error(err)
            }
        })
    }





}



// WEBPACK FOOTER //
// ./src/service/CardService.js